import { render, staticRenderFns } from "./ReferenceIndexesList.vue?vue&type=template&id=4da75a82&"
import script from "./ReferenceIndexesList.vue?vue&type=script&lang=js&"
export * from "./ReferenceIndexesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports